import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import type { UpdateEmailTemplateInput } from '@klaro7/validators';

import {
  getEmailTemplates,
  updateEmailTemplate,
} from '../services/emailTemplate.service';

export function useEmailTemplates() {
  return useQuery({
    queryKey: ['settings', 'email-templates'],
    queryFn: getEmailTemplates,
  });
}

export function useUpdateEmailTemplate() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ slug, data }: { slug: string; data: UpdateEmailTemplateInput }) =>
      updateEmailTemplate(slug, data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['settings', 'email-templates'] });
    },
  });
}
